export function uselocalStorageGetterSetter() {
  function setObject(key, obj) {
    localStorage.setItem(key, JSON.stringify(obj));
  }

  function getParsedObject(key) {
    return JSON.parse(localStorage.getItem(key));
  }

  function getNewFeaturesObject() {
    return JSON.parse(localStorage.getItem('NEW_FEATURES')) || {};
  }

  function setNewFeaturesObject(obj) {
    // check what happens, but maybe grab what's in local storage already, spread it then add newly passed
    const currentLocalStor = getNewFeaturesObject();
    const newLocalStor = { ...currentLocalStor, ...obj };
    localStorage.setItem('NEW_FEATURES', JSON.stringify(newLocalStor));
  }

  function getNewFeatureByKey(key) {
    return getNewFeaturesObject()[key];
  }

  function setNewFeatureByKey(key, value) {
    const currentLocalStor = getNewFeaturesObject();
    // add or update new value
    currentLocalStor[key] = value;
    // save to local storage
    setNewFeaturesObject(currentLocalStor);
  }

  return {
    setObject,
    getParsedObject,
    getNewFeaturesObject,
    setNewFeaturesObject,
    getNewFeatureByKey,
    setNewFeatureByKey,
  };
}
